export enum ModuleName {
  Communication = 'Communication',
  Risk = 'Risk',
  Identity = 'Identity',
  JMIdentity = 'JM Identity',
  Membership = 'Membership',
  Content = 'Content',
  Payment = 'Payment',
  Document = 'Document',
  Account = 'Account',
  Reporting = 'Reporting',
  ShoppingCart = 'Shopping Cart',
  Shipping = 'Shipping',
  Billing = 'Billing',
  Appraisals = 'Appraisals',
  PointOfSaleIntegration = 'Point Of Sale Integration',
  DiamondMarketplace = 'Diamond Marketplace',
  Memo = 'Memo',
  JewelerPages = 'Jeweler Pages',
  Auction = 'Auction',
  PromoCode = 'Promo Code',
  Security = 'Security',
  Entity = 'Entity',
  Party = 'Party',
  BulkUpload = 'Bulk Upload',
  TermsAndConditions = 'Terms And Conditions',
  RetailLocation = 'Retail Location',
  ProgramEnrollments = 'Program Enrollments',
  IncentivePrograms = 'Incentive Programs'
}
